<template>
  <div>
    <component :is="layout">
      <slot />
    </component>
  </div>
</template>
<script>

export default {
  name:"RootLayout",
  data() {
    return {};
  },

  computed: {
    layout() {
      // let layout = this.$route.meta.layout || "Public";
      // return () => import(`./${layout}.vue`);
      return (this.$route.meta.layout || 'public') + '-layout'
    },
  },
};
</script>
<style scoped>
</style>